/**
 * SignOutButton — client island for the AppHeader.
 *
 * Calls `signOut()` on the better-auth React client which expires the
 * session cookie, then navigates back to /sign-in.
 */
"use client";

import * as React from "react";
import { useRouter } from "next/navigation";

import { signOut } from "@/lib/auth-client";

export function SignOutButton(): React.JSX.Element {
  const router = useRouter();
  const [pending, setPending] = React.useState(false);

  async function onClick() {
    if (pending) return;
    setPending(true);
    try {
      await signOut();
      router.push("/sign-in");
      router.refresh();
    } catch (err) {
      console.error("[sign-out] failed:", err);
      setPending(false);
    }
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={pending}
      className="rounded-md border border-[var(--color-border)] bg-[var(--color-bg-surface)] px-3 py-1 text-[var(--text-body-sm)] text-[var(--color-fg-primary)] hover:bg-[var(--color-bg-hover)] disabled:opacity-50"
      aria-label="Sign out"
    >
      {pending ? "Çıkış…" : "Çıkış"}
    </button>
  );
}
